export const WELL_TOPS_URL = "/files/wellbore-tops.json";
